import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "../pages/HomePage";
import LoginPage from "../pages/LoginPage";
import RegisterPage from "../pages/RegisterPage";
import VerifyOTP from "../pages/VerifyOTP";
import VerifyPhone from "../pages/VerifyPhone";
import ItemDetails from "../pages/ItemDetails";
import ItemsList from "../pages/ItemsList";
import SearchPage from "../pages/SearchPage";
import AddressList from "../pages/AddressList";
import AddAddress from "../pages/AddAddress";
import AddCard from "../pages/AddCard";
import Cart from "../pages/Cart";
import Checkout from "../pages/Checkout";
import MyOrders from "../pages/MyOrders";
import OrderDetail from "../pages/OrderDetail";
import Account from "../pages/Account";
import Profile from "../pages/Profile";
import Points from "../pages/Points";
import Promotions from "../pages/Promotions";
import PromotionDetails from "../pages/PromotionDetails";
import Notifications from "../pages/Notifications";
import NotFound from "../pages/NotFound";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import AppLayout from '../pages/AppLayout';
import UnderMaintenance from "../pages/UnderMaintenance";


const AppRouter = () => {
  const basePath = process.env.REACT_APP_BASE_PATH;
  return (
    <Router basename={basePath}>
      <Routes >
        <Route  element={<AppLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/verify-phone" element={<VerifyPhone />} />
          <Route path="/verify-otp" element={<VerifyOTP />} />

          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/search" element={<SearchPage />} />
          <Route path="/items/:id?" element={<ItemsList />} />
          <Route path="/item/:id" element={<ItemDetails />} />
          <Route path="/address-list" element={<AddressList />} />
          <Route path="/add-address" element={<AddAddress />} />
          <Route path="/add-card" element={<AddCard />} />

          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/my-orders" element={<MyOrders />} />
          <Route path="/order/:id" element={<OrderDetail />} />
          <Route path="/account" element={<Account />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/points" element={<Points />} />
          <Route path="/promotions" element={<Promotions />} />
          <Route path="/promo/:id" element={<PromotionDetails />} />
          <Route path="/notifications" element={<Notifications />} />

          <Route path="/under-maintenance" element={<UnderMaintenance />} />

          <Route path="*" element={<NotFound />} /> 

        </Route>
      </Routes>
    </Router>
  );
};

export default AppRouter;
